import { useSelector } from 'react-redux';

import { WorkspacesListingItem } from '@futrli-sdk/workspaces';

import { StoreState } from '../../../redux-helpers/types';
import { workspacesSelector } from '../../redux-utils/selectors';

/**
 * Returns all workspaces from the normalised redux store
 */
export const useWorkspacesSelector = () => {
  return useSelector((store: StoreState) => {
    const { normalised } = store;
    return workspacesSelector(normalised) as WorkspacesListingItem[];
  });
};
